import { NavLink } from 'react-router-dom'
import type { ReactNode } from 'react'

import { useTranslation } from '../hooks/useTranslation'

interface NavItem {
  id: string
  labelKey: string
  icon: ReactNode
  href: string
  badge?: { count: number; color: 'primary' | 'warning' | 'error' }
}

interface SidebarNavProps {
  items: NavItem[]
  collapsed?: boolean
}

export const SidebarNav = ({ items, collapsed = false }: SidebarNavProps) => {
  const { t } = useTranslation()

  return (
    <nav className="h-full flex flex-col">
      {/* Nav items */}
      <div className={`flex-1 overflow-y-auto py-3 ${collapsed ? 'px-1' : 'px-2'}`}>
        {items.map((item) => {
          const label = t(item.labelKey)

          return (
            <NavLink
              key={item.id}
              to={item.href}
              title={label}
              className={({ isActive }) =>
                `flex items-center ${collapsed ? 'justify-center px-0' : 'gap-3 px-3'} py-[10px] min-h-[40px] rounded-md mb-[2px] transition-all duration-150 border-l-[3px] text-[13px] font-medium ${
                  isActive
                    ? 'text-primary-red bg-primary-red/10 border-l-primary-red'
                    : 'text-text-secondary hover:text-text-primary hover:bg-bg-surface border-l-transparent'
                }`
              }
            >
              <span className={`${collapsed ? 'text-[18px]' : 'text-[16px]'} w-5 text-center flex-shrink-0`}>
                {item.icon}
              </span>

              {!collapsed && <span className="flex-1">{label}</span>}

              {!collapsed && item.badge && (
                <span
                  className={`
                    inline-flex items-center justify-center min-w-[24px] h-5 px-2 rounded-xl
                    text-[10px] font-semibold
                    ${
                      item.badge.color === 'primary'
                        ? 'bg-primary-red text-white'
                        : item.badge.color === 'warning'
                          ? 'bg-warning text-text-inverse'
                          : 'bg-error text-white'
                    }
                  `}
                >
                  {item.badge.count}
                </span>
              )}
            </NavLink>
          )
        })}
      </div>

    </nav>
  )
}
